<login-form
  [accountVerification]="true"
  [key]="key"></login-form>
